import React from 'react';
import CloseButton from 'components/UI/CloseButton';
import { useTrans } from 'utils/localisation';
import * as styles from './ModalHeader.module.scss';

function ModalHeader({ handleClose }) {
  const t = useTrans(['filters']);

  return (
    <div className={styles.modalHeader}>
      <div className={styles.navigation}>
        <div className={styles.text}>{t('filters')}</div>
        <CloseButton className={styles.closeButton} onClose={handleClose} theme="dark" size="sm" />
      </div>
    </div>
  );
}

export default ModalHeader;
